export enum TemporaryCategory {
  NO_CATEGORY = "cat11111-1111-1111-1111-111111111111",
}

export const TemporaryCategoryInfo = {
  [TemporaryCategory.NO_CATEGORY]: { name: "No Category" },
} as const;

export const getTemporaryCategoryName = (value: TemporaryCategory): string =>
  TemporaryCategoryInfo[value].name;

export enum TemporaryBrand {
  NO_BRAND = "brnd1111-1111-1111-1111-111111111111",
}

export const TemporaryBrandInfo = {
  [TemporaryBrand.NO_BRAND]: { name: "No Brand" },
} as const;

export const getTemporaryBrandName = (value: TemporaryBrand): string =>
  TemporaryBrandInfo[value].name;

export enum Units {
  PCS = "units01-1111-1111-1111-111111111111",
  KG = "units02-2222-2222-2222-222222222222",
  G = "units03-3333-3333-3333-333333333333",
  ML = "units04-4444-4444-4444-444444444444",
  L = "units05-5555-5555-5555-555555555555",
  M = "units06-6666-6666-6666-666666666666",
  BOX = "units07-7777-7777-7777-777777777777",
  PACK = "units08-8888-8888-8888-888888888888",
  BOTTLE = "units09-9999-9999-9999-999999999999",
  CAN = "units10-1010-1010-1010-101010101010",
}

export const UnitsInfo = {
  [Units.PCS]: { name: "Pcs" },
  [Units.KG]: { name: "Kg" },
  [Units.G]: { name: "G" },
  [Units.ML]: { name: "Ml" },
  [Units.L]: { name: "L" },
  [Units.M]: { name: "M" },
  [Units.BOX]: { name: "Box" },
  [Units.PACK]: { name: "Pack" },
  [Units.BOTTLE]: { name: "Bottle" },
  [Units.CAN]: { name: "Can" },
} as const;

export const getUnitsName = (value: Units): string => UnitsInfo[value].name;

export enum TemporaryItemProduct {
  PRODUCT = "tempr111-1111-1111-1111-111111111111",
  CATEGORY = "cat11111-1111-1111-1111-111111111111",
  BRAND = "brnd1111-1111-1111-1111-111111111111",
  STOCK = "temstck1-1111-1111-1111-111111111111",
}

export const TemporaryItemProductInfo = {
  [TemporaryItemProduct.PRODUCT]: { name: "Temporary Product" },
  [TemporaryItemProduct.CATEGORY]: { name: "No Category" },
  [TemporaryItemProduct.BRAND]: { name: "No Brand" },
  [TemporaryItemProduct.STOCK]: { name: "Temporary Stock" },
} as const;


